var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart-div"},[_c('pie-chart',{attrs:{"data":_vm.chartData[0],"options":_vm.chartOptions,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }